export var delayAfterPollingInMS = 1100;
export var delayBeforeStartPollingInMS = 400;
